module.exports = __webpack_public_path__ + "js/components/Explorer/ContentWindow/ExplorerFile/winamp-icon-ae4b1f48e3ab6ae03f9fce1a966292b6.png";